import React from 'react';

const ProfileField = React.memo(({ 
  label, 
  value, 
  fieldKey, 
  link = null, 
  showEdit = true, 
  type = 'text',
  isEditing,
  editData,
  handleFieldChange,
  getNestedValue
}) => (
  <div className="flex items-center justify-between py-4 ">
    <div className="flex-1">
      <div className="text-sm font-medium text-gray-600 mb-1">{label}</div>
      {isEditing && showEdit ? (
        type === 'select' ? (
          <select
            className={`border rounded px-2 py-1 text-gray-900 text-sm font-medium w-full transition-all duration-200 ${isEditing && showEdit ? 'bg-yellow-50 border-yellow-400 focus:ring-2 focus:ring-yellow-300' : ''}`}
            value={getNestedValue(editData, fieldKey) || ''}
            onChange={e => handleFieldChange(fieldKey, e.target.value)}
          >
            {fieldKey === 'gender' && [
              <option key="" value="">Select Gender</option>,
              <option key="Male" value="Male">Male</option>,
              <option key="Female" value="Female">Female</option>
            ]}
            {fieldKey === 'bloodGroup' && [
              <option key="" value="">Select Blood Group</option>,
              <option key="A+" value="A+">A+</option>,
              <option key="A-" value="A-">A-</option>,
              <option key="B+" value="B+">B+</option>,
              <option key="B-" value="B-">B-</option>,
              <option key="O+" value="O+">O+</option>,
              <option key="O-" value="O-">O-</option>,
              <option key="AB+" value="AB+">AB+</option>,
              <option key="AB-" value="AB-">AB-</option>
            ]}
          </select>
        ) : (
          <input
            className={`border-[2px] rounded-xl px-5 py-3 text-gray-900 text-sm font-medium w-full transition-all duration-200 ${isEditing && showEdit ? 'bg-yellow-50 border-yellow-400 focus:ring-2 focus:ring-yellow-300' : ''}`}
            value={getNestedValue(editData, fieldKey) || ''}
            onChange={e => handleFieldChange(fieldKey, e.target.value)}
            type={type}
          />
        )
      ) : link ? (
        <a href={link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-600 text-sm">
          {value}
        </a>
      ) : (
        <div className="text-gray-900 border-[2px] rounded-xl px-5 py-3 text-sm font-medium">{value}</div>
      )}
    </div>
  </div>
));

export default ProfileField; 